import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// One-tap "Save for later" bookmark usable on any card or page.
export const SaveButton = ({ item, variant = "overlay", onChange }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [saved, setSaved] = useState(!!item.saved);
  useEffect(() => setSaved(!!item.saved), [item.saved]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { toast("Sign in to save posts"); return nav("/login"); }
    const next = !saved;
    setSaved(next);
    try {
      const { data } = await api.post(`/media/${item.id}/save`);
      setSaved(data.saved);
      onChange?.(data.saved);
      toast.success(data.saved ? "Saved for later" : "Removed from saved");
    } catch {
      setSaved(!next);
      toast.error("Couldn't save");
    }
  };

  const cls = variant === "overlay"
    ? `absolute top-3 left-3 z-10 grid place-items-center w-8 h-8 rounded-full border backdrop-blur-md transition-all ${saved ? "bg-[#F1A817] border-[#F1A817] text-black opacity-100" : "bg-black/50 border-white/15 text-white opacity-100 md:opacity-0 md:group-hover:opacity-100 hover:bg-[#F1A817] hover:text-black"}`
    : `flex items-center gap-1.5 px-3 py-2 rounded-full border text-xs transition-colors ${saved ? "bg-[#F1A817] border-[#F1A817] text-black" : "border-white/10 text-white hover:border-[#F1A817] hover:text-[#F1A817]"}`;

  return (
    <button type="button" data-testid={`save-btn-${item.id}`} onClick={toggle} title={saved ? "Saved" : "Save for later"} aria-pressed={saved} className={cls}>
      <Bookmark size={variant === "overlay" ? 14 : 14} fill={saved ? "currentColor" : "none"} />
      {variant !== "overlay" && (saved ? "Saved" : "Save")}
    </button>
  );
};
